"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[504],{

/***/ 94662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DelayedHover; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48465);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20597);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* eslint-disable react/default-props-match-prop-types */ 



var DelayedHover = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(DelayedHover, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(DelayedHover);
    function DelayedHover(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, DelayedHover);
        var _this;
        _this = _super.call(this, props);
        _this.handleMouseEnter = function() {
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function() {
                _this.setState({
                    hover: true
                });
            }, _this.props.ms);
        };
        _this.handleMouseLeave = function() {
            clearTimeout(_this.timeout);
            _this.timeout = setTimeout(function() {
                _this.setState({
                    hover: false
                });
            }, _this.props.ms / 2);
        };
        _this.state = {
            hover: false
        };
        return _this;
    }
    var _proto = DelayedHover.prototype;
    _proto.render = function render() {
        return this.props.children({
            hover: this.state.hover,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        });
    };
    return DelayedHover;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);



/***/ }),

/***/ 79313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _components_DelayedHover__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94662);
/* harmony import */ var _govlaunch_popover__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70271);







function Tooltip(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_DelayedHover__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ms: 200,
        children: function(param) {
            var hover = param.hover, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_popover__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                placement: "top",
                isOpen: hover
            }, props), {
                boxStyle: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props.boxStyle || {}), {
                    zIndex: 1050
                }),
                children: function(param) {
                    var innerRef = param.innerRef;
                    return children({
                        hover: hover,
                        bind: {
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave
                        },
                        innerRef: innerRef
                    });
                }
            }));
        }
    });
};


/***/ }),

/***/ 56906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MakersProIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




function MakersProIcon(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 80,
        height: 80,
        viewBox: "0 0 80 80"
    }, props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("defs", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("linearGradient", {
                    x1: "12.566%",
                    y1: "11.838%",
                    x2: "90.081%",
                    y2: "100%",
                    id: "fsa2h4shrarhj",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                            stopColor: "#55A2FA",
                            offset: "0%"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("stop", {
                            stopColor: "#B4EC51",
                            offset: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("g", {
                fillRule: "nonzero",
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                        d: "M40 0c22.063 0 40 17.937 40 40S62.063 80 40 80 0 62.063 0 40 17.937 0 40 0z",
                        fill: "url(#fsa2h4shrarhj)"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("g", {
                        fill: "#FFF",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                            d: "M28.626 64v-3.094h1.708c1.946 0 3.262-1.456 3.262-3.472s-1.316-3.444-3.262-3.444h-4.158V64h2.45zm1.204-5.194h-1.204V56.09h1.246c.812 0 1.232.546 1.232 1.344s-.42 1.372-1.274 1.372zM38.082 64v-3.374h1.148L41.008 64h2.73l-1.946-3.5c-.238-.42-.378-.602-.378-.602v-.028c.994-.504 1.498-1.666 1.498-2.73 0-1.456-.714-2.478-1.848-2.912-.434-.168-.924-.238-1.946-.238h-3.486V64h2.45zm1.064-5.474h-1.064V56.09h.826c1.232 0 1.512.448 1.512 1.204 0 .798-.49 1.232-1.274 1.232zm11.136 5.642c3.024 0 5.236-2.296 5.236-5.236 0-2.87-2.212-5.11-5.236-5.11-3.024 0-5.236 2.24-5.236 5.11 0 2.94 2.212 5.236 5.236 5.236zm0-2.24c-1.498 0-2.702-1.288-2.702-2.996 0-1.638 1.204-2.87 2.702-2.87s2.702 1.232 2.702 2.87c0 1.708-1.204 2.996-2.702 2.996zM49.706 28.177l-7.992 16.47h-3.899l-7.992-16.47V47H23V17h8.967l7.603 16.47L47.367 17h8.967v30h-6.628z"
                        })
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 49289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PlusIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




function PlusIcon(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 15 15",
        width: 15,
        height: 15
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M13.929 6.429H8.57V1.07a1.072 1.072 0 0 0-2.142 0V6.43H1.07a1.072 1.072 0 0 0 0 2.142H6.43v5.358a1.072 1.072 0 0 0 2.142 0V8.57h5.358a1.072 1.072 0 0 0 0-2.142z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
};


/***/ }),

/***/ 84743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ invite_Collaborator; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./components/Tooltip.tsx
var Tooltip = __webpack_require__(79313);
// EXTERNAL MODULE: ./lib/mutations/RemoveInvitee.ts
var RemoveInvitee = __webpack_require__(56250);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
;// CONCATENATED MODULE: ./components/icons/QuestionMarkIcon.tsx





function QuestionMark(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 53 53"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18.613 41.552l-7.907 4.313a7.106 7.106 0 0 0-1.269.903A26.377 26.377 0 0 0 26.5 53c6.454 0 12.367-2.31 16.964-6.144a7.015 7.015 0 0 0-1.394-.934l-8.467-4.233a3.229 3.229 0 0 1-1.785-2.888v-3.322c.238-.271.51-.619.801-1.03a19.482 19.482 0 0 0 2.632-5.304c1.086-.335 1.886-1.338 1.886-2.53v-3.546c0-.78-.347-1.477-.886-1.965v-5.126s1.053-7.977-9.75-7.977-9.75 7.977-9.75 7.977v5.126a2.644 2.644 0 0 0-.886 1.965v3.546c0 .934.491 1.756 1.226 2.231.886 3.857 3.206 6.633 3.206 6.633v3.24a3.232 3.232 0 0 1-1.684 2.833z",
                fill: palette/* washGray */.aF
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M26.953.004C12.32-.246.254 11.414.004 26.047-.138 34.344 3.56 41.801 9.448 46.76a7.041 7.041 0 0 1 1.257-.894l7.907-4.313a3.23 3.23 0 0 0 1.683-2.835v-3.24s-2.321-2.776-3.206-6.633a2.66 2.66 0 0 1-1.226-2.231v-3.546c0-.78.347-1.477.886-1.965v-5.126S15.696 8 26.499 8s9.75 7.977 9.75 7.977v5.126c.54.488.886 1.185.886 1.965v3.546c0 1.192-.8 2.195-1.886 2.53a19.482 19.482 0 0 1-2.632 5.304c-.291.411-.563.759-.801 1.03V38.8c0 1.223.691 2.342 1.785 2.888l8.467 4.233a7.05 7.05 0 0 1 1.39.932c5.71-4.762 9.399-11.882 9.536-19.9C53.246 12.32 41.587.254 26.953.004z",
                fill: palette/* sealBlue */.N9
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/invite/Collaborator.tsx













var Collaborator = function(param) {
    var user = param.user, viewerCanRemove = param.viewerCanRemove, targetId = param.targetId, targetType = param.targetType, _removeText = param.removeText, removeText = _removeText === void 0 ? "Remove Collaborator" : _removeText, _size = param.size, size = _size === void 0 ? 54 : _size;
    var intl = (0,useIntl/* default */.Z)();
    var loggedInUser = (0,Auth/* useSelfie */.yD)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
        backgroundColor: palette/* innovatorBlue */.LD,
        borderColor: palette/* innovatorBlue */.LD,
        render: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    padding: 6,
                    color: palette/* white */.ix
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            fontWeight: 600,
                            fontSize: 14
                        },
                        children: user.fullName ? user.fullName : getCollaboratorLabel(user, intl)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            fontSize: 12
                        },
                        children: getUserFrom(user, intl)
                    })
                ]
            });
        },
        children: function(param) {
            var bind = param.bind, innerRef = param.innerRef;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                backgroundColor: palette/* red */.Q6,
                borderColor: palette/* red */.Q6,
                render: function() {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            padding: 6,
                            fontWeight: 600,
                            color: palette/* white */.ix,
                            fontSize: 14
                        },
                        children: removeText
                    });
                },
                children: function(param) {
                    var removeBind = param.bind, removeInnerRef = param.innerRef;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "inline-flex",
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                position: "relative"
                            },
                            children: [
                                (viewerCanRemove || loggedInUser && loggedInUser._id === user._id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                    mutation: RemoveInvitee/* default */.Z,
                                    variables: {
                                        targetId: targetId,
                                        targetType: targetType,
                                        inviteeId: user._id
                                    },
                                    children: function(remove) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, removeBind), {
                                            ref: removeInnerRef,
                                            role: "button",
                                            css: {
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: -5,
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "100%",
                                                right: -5,
                                                width: 22,
                                                height: 22,
                                                background: palette/* red */.Q6
                                            },
                                            onClick: function() {
                                                if (window.confirm(targetType === "GOVERNMENT" ? intl.formatMessage({
                                                    defaultMessage: "Do you want to remove this team member?",
                                                    id: "zvf/vl"
                                                }) : intl.formatMessage({
                                                    defaultMessage: "Do you want to remove this collaborator?",
                                                    id: "l18Y6G"
                                                }))) {
                                                    remove().then(function() {
                                                        if (loggedInUser && loggedInUser._id === user._id) {
                                                            window.location.reload();
                                                        }
                                                    });
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                                width: 10,
                                                height: 10,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    fill: "#FFF",
                                                    d: "M6.188 5l3.566-3.565A.84.84 0 1 0 8.565.246L5 3.812 1.435.246A.84.84 0 1 0 .246 1.435L3.812 5 .246 8.565a.84.84 0 0 0 1.189 1.189L5 6.188l3.565 3.566a.84.84 0 1 0 1.189-1.189L6.188 5z"
                                                })
                                            })
                                        }));
                                    }
                                }),
                                user.fullName ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    passHref: true,
                                    href: "/[userSlug]/[[...tab]]",
                                    as: "/@".concat(user.slug),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            image: user.avatar,
                                            name: user.fullName,
                                            size: size
                                        }, bind), {
                                            innerRef: innerRef,
                                            css: {
                                                position: "static"
                                            }
                                        }))
                                    })
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    ref: innerRef
                                }, bind), {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuestionMark, {
                                        width: 54,
                                        height: 54
                                    })
                                }))
                            ]
                        })
                    });
                }
            });
        }
    });
};
function getCollaboratorLabel(user, intl) {
    if (user.government) {
        return intl.formatMessage({
            defaultMessage: "Member of {governmentName}",
            id: "MQIpSq"
        }, {
            governmentName: user.government.name
        });
    // return `Member of ${((user as IGovernmentUser).government as IGovernment).name}`;
    }
    if (user.company) {
        return intl.formatMessage({
            defaultMessage: "Member of {vendorName}",
            id: "8XFmhR"
        }, {
            vendorName: user.company.name
        });
    // return `Member of ${((user as IVendorUser).company as ICompany).name}`;
    }
    return intl.formatMessage({
        defaultMessage: "Member of Govlaunch",
        id: "hT39cQ"
    });
}
function getUserFrom(user, intl) {
    // The government/vendor information will be shown on his label
    if (!user.fullName) {
        return null;
    }
    if (user.__typename === "GovernmentUser" && user.government) {
        // return `from ${user.government.name}`;
        return intl.formatMessage({
            defaultMessage: "from {governmentName}",
            id: "g3HBt2"
        }, {
            governmentName: user.government.name
        });
    }
    if (user.__typename === "VendorUser" && user.company) {
        return intl.formatMessage({
            defaultMessage: "from {vendorName}",
            id: "GsNpiZ"
        }, {
            vendorName: user.company.name
        });
    // return `from ${user.company.name}`;
    }
    return null;
}
/* harmony default export */ var invite_Collaborator = (Collaborator);


/***/ }),

/***/ 96805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ invite_InviteModal; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.8.1_psntm5zmlvip7zjgnrjqfe3wg4/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(43893);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/noop.js
var noop = __webpack_require__(98483);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./lib/hooks/useClipboard.ts
var useClipboard = __webpack_require__(91472);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./lib/mutations/GetInviteToken.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation GetInviteToken($targetType: String!, $targetId: String!) {\n    getInviteToken(targetType: $targetType, targetId: $targetId)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetInviteToken = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./lib/mutations/SendInvites.ts

function SendInvites_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SendInvites($targetType: String!, $targetId: String!, $emails: [String]) {\n    sendInvites(targetType: $targetType, targetId: $targetId, emails: $emails)\n  }\n"
    ]);
    SendInvites_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SendInvites = ((0,lib/* gql */.Ps)(SendInvites_templateObject()));

// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/icons/PlusIcon.tsx
var PlusIcon = __webpack_require__(49289);
;// CONCATENATED MODULE: ./components/invite/components/CopyIcon.tsx




var CopyIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 17,
        height: 18,
        fill: "red"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__a",
                        x1: "49.995%",
                        x2: "49.995%",
                        y1: "2510.674%",
                        y2: "-1191.051%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "32.2%",
                                stopColor: "#A163F5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "46.6%",
                                stopColor: "#B074EE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "75.2%",
                                stopColor: "#D8A1DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "89.8%",
                                stopColor: "#EFBAD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__b",
                        x1: "50.002%",
                        x2: "50.002%",
                        y1: "2510.674%",
                        y2: "-1191.051%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "32.2%",
                                stopColor: "#A163F5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "46.6%",
                                stopColor: "#B074EE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "75.2%",
                                stopColor: "#D8A1DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "89.8%",
                                stopColor: "#EFBAD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__c",
                        x1: "49.999%",
                        x2: "49.999%",
                        y1: "2510.674%",
                        y2: "-1191.051%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "32.2%",
                                stopColor: "#A163F5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "46.6%",
                                stopColor: "#B074EE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "75.2%",
                                stopColor: "#D8A1DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "89.8%",
                                stopColor: "#EFBAD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__d",
                        x1: "50%",
                        x2: "50%",
                        y1: "2070.146%",
                        y2: "-1631.579%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "32.2%",
                                stopColor: "#A163F5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "46.6%",
                                stopColor: "#B074EE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "75.2%",
                                stopColor: "#D8A1DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "89.8%",
                                stopColor: "#EFBAD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__e",
                        x1: "49.999%",
                        x2: "49.999%",
                        y1: "2070.146%",
                        y2: "-1631.579%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "32.2%",
                                stopColor: "#A163F5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "46.6%",
                                stopColor: "#B074EE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "75.2%",
                                stopColor: "#D8A1DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "89.8%",
                                stopColor: "#EFBAD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__f",
                        x1: "50%",
                        x2: "50%",
                        y1: "1602.145%",
                        y2: "-2099.58%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "32.2%",
                                stopColor: "#A163F5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "46.6%",
                                stopColor: "#B074EE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "75.2%",
                                stopColor: "#D8A1DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "89.8%",
                                stopColor: "#EFBAD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__g",
                        x1: "49.997%",
                        x2: "49.997%",
                        y1: "1169.626%",
                        y2: "-2532.099%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "32.2%",
                                stopColor: "#A163F5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "46.6%",
                                stopColor: "#B074EE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "75.2%",
                                stopColor: "#D8A1DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "89.8%",
                                stopColor: "#EFBAD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                        id: "prefix__h",
                        x1: "50%",
                        x2: "50%",
                        y1: "95.985%",
                        y2: "3.942%",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "32.2%",
                                stopColor: "#A163F5"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "46.6%",
                                stopColor: "#B074EE"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "75.2%",
                                stopColor: "#D8A1DD"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                                offset: "89.8%",
                                stopColor: "#EFBAD3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                fill: "none",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__a)",
                        d: "M10.093 6.483h.96a.224.224 0 1 0 .001-.448h-.961a.224.224 0 0 0 0 .447z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__b)",
                        d: "M5.86 6.483h3.371a.224.224 0 0 0 0-.447h-3.37c-.125 0-.226.1-.226.223s.101.224.225.224z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__c)",
                        d: "M3.548 6.483h1.433c.125 0 .226-.1.226-.224s-.101-.224-.226-.224H3.548a.224.224 0 0 0 0 .447z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__d)",
                        d: "M8.696 8.005H4.704c-.125 0-.226.1-.226.224 0 .123.101.224.226.224h3.992a.224.224 0 1 0 0-.448z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__e)",
                        d: "M3.548 8.453h.418a.224.224 0 1 0 0-.448h-.418a.224.224 0 0 0 0 .447z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__f)",
                        d: "M3.548 10.546h2.674a.224.224 0 0 0 0-.447H3.548c-.124 0-.225.1-.225.223s.1.224.225.224z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__g)",
                        d: "M4.629 12.033H3.548a.224.224 0 0 0 0 .447h1.08a.224.224 0 0 0 .001-.447z"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                        fill: "url(#prefix__h)",
                        d: "M16.597 4.953a.966.966 0 0 0-1.33-.273l-.245.16h-.001l-.43.28V1.832a.959.959 0 0 0-.962-.954H8.7A1.55 1.55 0 0 0 7.302 0a1.55 1.55 0 0 0-1.399.877H.972c-.53 0-.96.427-.96.954v15.2c0 .527.43.954.96.954H13.63c.53 0 .96-.427.961-.954V7.878l1.95-1.272a.951.951 0 0 0 .276-1.322l-.219-.33zm-8.359 6.535l-.266-.403 7.622-4.973.266.402-7.622 4.974zm4.195 1.938H11.25c-.53 0-.96.427-.961.954v1.146H2.31a.143.143 0 0 1-.143-.142V3.479c0-.079.064-.142.143-.142h1.012v.613c0 .124.1.224.225.224h7.506c.124 0 .225-.1.225-.224v-.613h1.012c.078 0 .142.063.142.142v3.049l-5.41 3.53a.163.163 0 0 0-.016.012.217.217 0 0 0-.037.037l-.004.005a.208.208 0 0 0-.012.018l-.002.003-1.023 1.75-.304.199a.223.223 0 0 0-.065.31.226.226 0 0 0 .312.063l.304-.198L8.2 12.02l.004-.001.01-.002a.207.207 0 0 0 .077-.03l.006-.003 4.136-2.698v4.14zm-.309.447l-1.386 1.377v-.87a.51.51 0 0 1 .51-.507h.876zm-4.338-2.255l-1.268.149.64-1.097.314.474.314.474zm-.061-.906l-.266-.403 7.032-4.588.59-.385.266.402-7.622 4.974zm5.904-9.388a.51.51 0 0 1 .511.507v3.583l-1.256.82V3.48a.592.592 0 0 0-.593-.59h-1.012v-.692c0-.124-.1-.224-.225-.224H8.85V1.54a1.55 1.55 0 0 0-.016-.215h4.794zM7.301.447c.607 0 1.099.49 1.1 1.092v.658c0 .123.1.223.224.223h2.204v1.307H3.773V2.42h2.203c.125 0 .225-.1.225-.223v-.658a1.098 1.098 0 0 1 1.1-1.092zm6.839 16.584a.51.51 0 0 1-.51.507H.971a.51.51 0 0 1-.51-.507v-15.2a.51.51 0 0 1 .51-.507h4.794a1.55 1.55 0 0 0-.015.215v.434H3.548c-.124 0-.225.1-.225.224v.692H2.31a.592.592 0 0 0-.593.59v11.905c0 .325.266.588.593.589h8.06a.7.7 0 0 0 .088-.007.225.225 0 0 0 .223-.07.67.67 0 0 0 .16-.117l1.846-1.834a.656.656 0 0 0 .196-.468V8.992l1.256-.82v8.86zm2.153-10.799l-.056.037-.78-1.179.056-.036a.513.513 0 0 1 .708.145l.218.33a.506.506 0 0 1-.146.703z"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_CopyIcon = (CopyIcon);

;// CONCATENATED MODULE: ./components/invite/components/LinkIcon.tsx




function LinkIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 17,
        height: 17,
        viewBox: "0 0 503.118 503.118"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M335.151 167.967c10.449 10.449 18.808 22.988 25.078 35.527 22.988 48.065 15.673 108.669-25.078 148.375L223.347 464.718c-51.2 51.2-133.747 51.2-183.902 0-51.2-51.2-51.2-133.747 0-183.902l79.412-79.412c-9.404 31.347-8.359 64.784 3.135 95.086l-33.437 33.437c-22.988 22.988-22.988 61.649 0 85.682 24.033 24.033 61.649 24.033 85.682 0l111.804-111.804c11.494-11.494 17.763-27.167 17.763-42.841s-6.269-31.347-17.763-42.841c-11.494-11.494-27.167-17.763-42.841-17.763l56.424-56.424c12.539 5.223 24.033 13.582 35.527 24.031z",
                fill: "#ffd15c"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M167.967 335.151c-10.449-10.449-18.808-22.988-25.078-35.527-22.988-48.065-15.673-108.669 25.078-148.376L279.771 38.4c51.2-51.2 133.747-51.2 183.902 0 51.2 51.2 51.2 133.747 0 183.902l-79.412 79.412c9.404-31.347 8.359-64.784-3.135-95.086l33.437-33.437c22.988-22.988 22.988-61.649 0-85.682-24.033-24.033-61.649-24.033-85.682 0l-110.759 112.85c-11.494 11.494-17.763 27.167-17.763 42.841s6.269 31.347 17.763 42.841c11.494 11.494 27.167 17.763 42.841 17.763l-56.424 56.424c-13.584-6.269-25.078-14.628-36.572-25.077z",
                fill: "#ff7058"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./components/invite/InviteModal.tsx























function getInviteLink(token, redirectTo) {
    var href = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname);
    if (redirectTo) {
        return "".concat(href, "?token=").concat(token, "&redirectTo=").concat(redirectTo);
    }
    return "".concat(href, "?token=").concat(token);
}
var InviteModal = function(param) {
    var isOpen = param.isOpen, onRequestClose = param.onRequestClose, title = param.title, subtitle = param.subtitle, targetType = param.targetType, targetId = param.targetId, redirectTo = param.redirectTo, _inviteByEmail = param.inviteByEmail, inviteByEmail = _inviteByEmail === void 0 ? true : _inviteByEmail;
    var inputRef = /*#__PURE__*/ react.createRef();
    var submitButtonRef = /*#__PURE__*/ react.createRef();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useClipboard/* default */.Z)(inputRef), 2), copied = ref[0], setClipboard = ref[1];
    var selfie = (0,Auth/* useSelfie */.yD)();
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var intl = (0,useIntl/* default */.Z)();
    if (!selfie) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Modal */.u_, {
        onClose: onRequestClose,
        isOpen: isOpen,
        size: "md",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalOverlay */.ZA, {
                zIndex: 1401
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* ModalContent */.hz, {
                zIndex: 1402,
                borderRadius: "md",
                children: [
                    onRequestClose && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalCloseButton */.ol, {
                        onClick: onRequestClose,
                        zIndex: 1
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* ModalBody */.fe, {
                        borderRadius: "md",
                        py: 4,
                        px: 6,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareTitle, {
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShareSubtitle, {
                                children: subtitle
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                variables: {
                                    targetType: targetType,
                                    targetId: targetId
                                },
                                mutation: GetInviteToken,
                                children: function(getToken, param) {
                                    var data = param.data;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 12,
                                        children: !data ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InviteLinkButton, {
                                            type: "button",
                                            onClick: function() {
                                                if (selfie.__typename === "VendorUser" && selfie.company && targetType === "VENDOR" && !selfie.company.viewerCanInviteMembers) {
                                                    setError("Your current plan doesn't support more team members.");
                                                    return;
                                                }
                                                getToken();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    css: {
                                                        marginRight: 5
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Create invite link",
                                                        id: "u03Ges"
                                                    })
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkIcon, {})
                                            ]
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InviteLinkButton, {
                                                    type: "button",
                                                    onClick: function() {
                                                        return setClipboard();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                marginRight: 5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Copy invite link",
                                                                id: "rtACcE"
                                                            })
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CopyIcon, {})
                                                    ]
                                                }),
                                                copied && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    css: {
                                                        fontSize: 14,
                                                        color: palette/* greenBlue */.TG,
                                                        marginLeft: 8
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Copied!",
                                                        id: "0oL1zz"
                                                    })
                                                }),
                                                data.getInviteToken && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                    mt: 12,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                                                        value: getInviteLink(data.getInviteToken, redirectTo),
                                                        onChange: (noop_default()),
                                                        onFocus: function(e) {
                                                            return e.target.select();
                                                        },
                                                        size: "xsmall",
                                                        innerRef: inputRef
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                    mt: 8,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                        css: {
                                                            margin: 0,
                                                            fontSize: 12,
                                                            color: palette/* mediumGray */.rF,
                                                            "& strong": {
                                                                fontWeight: 500
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "This link will expire in 5 days",
                                                            id: "4wf8qW"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    });
                                }
                            }),
                            inviteByEmail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 12,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                            css: {
                                                fontSize: 14,
                                                color: palette/* darkGray */.O5,
                                                margin: 0
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "People you know",
                                                id: "/GvWeq"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 12,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                            mutation: SendInvites,
                                            children: function(sendInvites) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                                                    onSubmit: function(values) {
                                                        setError(null);
                                                        if (selfie.__typename === "VendorUser" && selfie.company && !selfie.company.viewerCanInviteMembers) {
                                                            setError(intl.formatMessage({
                                                                defaultMessage: "Your current plan doesn't support more team members.",
                                                                id: "U2MGCV"
                                                            }));
                                                            return;
                                                        }
                                                        sendInvites({
                                                            variables: {
                                                                targetType: targetType,
                                                                targetId: targetId,
                                                                emails: values.emails.filter(isValidEmail)
                                                            }
                                                        });
                                                        return;
                                                    },
                                                    initialValues: {
                                                        emails: [
                                                            ""
                                                        ]
                                                    },
                                                    validate: (0,validate/* default */.Z)(es/* object */.Ry().shape({
                                                        emails: es/* array */.IX().of(es/* string */.Z_().email(intl.formatMessage({
                                                            defaultMessage: "Invalid email address",
                                                            id: "5WgK3Y"
                                                        })))
                                                    })),
                                                    children: function(param) {
                                                        var handleSubmit = param.handleSubmit, values = param.values, form = param.form, dirty = param.dirty, invalid = param.invalid, submitSucceeded = param.submitSucceeded;
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                                                            onSubmit: handleSubmit,
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                    css: {
                                                                        display: "grid",
                                                                        rowGap: 8
                                                                    },
                                                                    children: values.emails.map(function(_, index) {
                                                                        var isLastField = values.emails.length === index + 1;
                                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                                            name: "emails[".concat(index, "]"),
                                                                            children: function(param) {
                                                                                var input = param.input, meta = param.meta;
                                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                                            css: {
                                                                                                display: "grid",
                                                                                                gridAutoFlow: "column",
                                                                                                gridTemplateColumns: isLastField ? "1fr auto" : "1fr",
                                                                                                gridColumnGap: 8
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                                                                                    placeholder: intl.formatMessage({
                                                                                                        defaultMessage: "Enter email address",
                                                                                                        id: "MnA9KQ"
                                                                                                    }),
                                                                                                    autoComplete: "off",
                                                                                                    autoFocus: index > 0
                                                                                                })),
                                                                                                isLastField && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddEmailButton, {
                                                                                                    type: "button",
                                                                                                    onClick: function() {
                                                                                                        if (input.value.trim() !== "" && !meta.error) {
                                                                                                            form.change("emails", values.emails.concat(""));
                                                                                                        }
                                                                                                    },
                                                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusIcon/* default */.Z, {})
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        meta.touched && meta.error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                                                            css: {
                                                                                                margin: "8px 0 0 0",
                                                                                                color: palette/* red */.Q6,
                                                                                                fontSize: 12
                                                                                            },
                                                                                            children: meta.error
                                                                                        })
                                                                                    ]
                                                                                });
                                                                            }
                                                                        }, index);
                                                                    })
                                                                }),
                                                                submitSucceeded && !dirty && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                                                    css: {
                                                                        fontSize: 12,
                                                                        margin: "8px 0 0 0",
                                                                        color: palette/* darkGray */.O5
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                            css: {
                                                                                fontWeight: 600,
                                                                                color: palette/* greenBlue */.TG
                                                                            },
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                                defaultMessage: "Sent!",
                                                                                id: "/xwYHP"
                                                                            })
                                                                        }),
                                                                        " ",
                                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                            defaultMessage: "You can also create an invite link above and send it directly to them.",
                                                                            id: "cOIisR"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                    mt: 12,
                                                                    css: {
                                                                        display: "flex",
                                                                        flexWrap: "wrap"
                                                                    },
                                                                    children: dirty ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                                color: palette/* greenBlue */.TG,
                                                                                textColor: palette/* white */.ix,
                                                                                size: "small",
                                                                                tabIndex: 1,
                                                                                type: "submit",
                                                                                padding: 8,
                                                                                disabled: invalid,
                                                                                css: {
                                                                                    ":disabled": {
                                                                                        opacity: 0.5
                                                                                    }
                                                                                },
                                                                                innerRef: submitButtonRef,
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                                    defaultMessage: "Send invite",
                                                                                    id: "oBB4L4"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                                theme: "link",
                                                                                textColor: palette/* red */.Q6,
                                                                                type: "reset",
                                                                                size: "small",
                                                                                padding: 8,
                                                                                onClick: form.reset,
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                                    defaultMessage: "Cancel",
                                                                                    id: "47FYwb"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                                        type: "button",
                                                                        color: palette/* innovatorBlue */.LD,
                                                                        size: "small",
                                                                        padding: "0 8px",
                                                                        height: 27,
                                                                        fontWeight: 500,
                                                                        onClick: onRequestClose,
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                            defaultMessage: "Done",
                                                                            id: "JXdbo8"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                mt: 8,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    css: {
                                        margin: 0,
                                        color: palette/* red */.Q6,
                                        fontSize: 14
                                    },
                                    children: error
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function isValidEmail(email) {
    return es/* string */.Z_().email().required().isValidSync(email);
}
function ShareTitle(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", (0,_object_spread/* default */.Z)({
        css: {
            margin: "0 0 4px 0",
            fontSize: 18,
            color: palette/* darkGray */.O5,
            fontWeight: 600
        }
    }, props));
}
function ShareSubtitle(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", (0,_object_spread/* default */.Z)({
        css: {
            fontWeight: 400,
            margin: 0,
            fontSize: 12,
            color: palette/* sealBlue */.N9,
            "& strong": {
                fontWeight: 500
            }
        }
    }, props));
}
var InviteLinkButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("button", {
    target: "ejgqduk0"
})({
    color: palette/* primary */.T$,
    background: "none",
    border: 0,
    outline: 0,
    padding: 0,
    fontSize: 14,
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer"
});
var AddEmailButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("button", {
    target: "ejgqduk1"
})({
    width: 42,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    borderRadius: 4,
    outline: "none",
    border: "solid 1px ".concat(palette/* lightestGray */.v2),
    cursor: "pointer",
    color: palette/* mediumGray */.rF
});
/* harmony default export */ var invite_InviteModal = (InviteModal);


/***/ }),

/***/ 589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UpgradeToMakersProBanner; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98973);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95576);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90489);
/* harmony import */ var _components_icons_MakersProIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56906);
/* harmony import */ var _components_spacings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52126);








function UpgradeToMakersProBanner() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
        css: {
            borderRadius: 4,
            border: "1px solid ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .lightestGray */ .v2),
            background: "#fff",
            textAlign: "center",
            padding: 32,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_icons_MakersProIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                width: 80,
                height: 80
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("h1", {
                css: {
                    fontSize: 36,
                    fontWeight: 800,
                    margin: "8px 0 8px",
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .text */ .fL
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    defaultMessage: "Upgrade to {plan}",
                    id: "/gko4g",
                    values: {
                        plan: "Makers Pro"
                    }
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                css: {
                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .mediumGray */ .rF,
                    textAlign: "center",
                    marginBottom: 24,
                    maxWidth: 500,
                    fontSize: 18
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    defaultMessage: "Unlock more tools to showcase your solutions and the ability to search other vendors and products.",
                    id: "iBvgld"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("img", {
                    src: "/static/makers/makers_pro_gating_15.png",
                    alt: "Upgrade to Makers Pro",
                    width: 600,
                    css: {
                        objectFit: "contain"
                    }
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_0__/* .Button */ .zx, {
                size: "large",
                theme: "primary",
                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .greenSuccess */ .CU,
                textColor: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .white */ .ix,
                css: {
                    minWidth: 300,
                    marginTop: 24
                },
                "data-intercom-target": "ContactUsForMakersPro",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    defaultMessage: "Contact Us",
                    id: "hZOGLS"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_spacings__WEBPACK_IMPORTED_MODULE_4__/* .Margin */ .Zt, {
                mt: 12,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/makers",
                    passHref: true,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("a", {
                        css: {
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .innovatorBlue */ .LD,
                            fontSize: 14
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                defaultMessage: "Learn more about",
                                id: "Clvypl"
                            }),
                            " ",
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                                css: {
                                    fontWeight: 600
                                },
                                children: "Makers Pro"
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 91472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClipboard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);

function useClipboard(innerRef) {
    var setClipboard = function setClipboard() {
        if (!innerRef.current) {
            return;
        }
        innerRef.current.select();
        document.execCommand("copy");
        innerRef.current.focus();
        setCopySuccess(true);
        setInterval(function() {
            return setCopySuccess(false);
        }, 2000);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), copySuccess = ref[0], setCopySuccess = ref[1];
    return [
        copySuccess,
        setClipboard
    ];
};


/***/ }),

/***/ 56250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation RemoveInvitee($targetId: String!, $targetType: String!, $inviteeId: ObjectId!) {\n    removeInvitee(targetId: $targetId, targetType: $targetType, inviteeId: $inviteeId)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 19805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleBookmark($targetId: ObjectId!, $targetType: BookmarkType!) {\n    toggleBookmark(targetId: $targetId, targetType: $targetType) {\n      __typename\n      ... on Product {\n        _id\n        viewerDidBookmark\n      }\n      ... on Story {\n        _id\n        viewerDidBookmark\n      }\n      ... on Project {\n        _id\n        viewerDidBookmark\n      }\n      ... on GovernmentPost {\n        _id\n        viewerDidBookmark\n      }\n      ... on GroupPost {\n        _id\n        viewerDidBookmark\n      }\n      ... on VendorPost {\n        _id\n        viewerDidBookmark\n      }\n      ... on Collection {\n        _id\n        viewerDidBookmark\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 22662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ToggleUpvote($targetId: ObjectId!, $targetType: UpvoteTargetType!) {\n    toggleUpvote(targetId: $targetId, targetType: $targetType) {\n      ... on Product {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on Story {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on Project {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on Comment {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on GovernmentPost {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n      ... on GroupPost {\n        _id\n        viewerDidUpvote\n        upvotesCount\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 32774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ validate; }
/* harmony export */ });
/* harmony import */ var lodash_fp_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35494);
/* harmony import */ var lodash_fp_set__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_set__WEBPACK_IMPORTED_MODULE_0__);

function validate(schema) {
    return function(values) {
        try {
            schema.validateSync(values, {
                abortEarly: false
            });
            return {};
        } catch (e) {
            return e.inner.reduce(function(errors, error) {
                if (typeof error.path !== "undefined") {
                    return lodash_fp_set__WEBPACK_IMPORTED_MODULE_0___default()(error.path, error.message, errors);
                }
            }, {});
        }
    };
};


/***/ }),

/***/ 51170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSignInModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _src_components_auth_SignInModalStateContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31480);


function useSignInModal() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_src_components_auth_SignInModalStateContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    return {
        open: context.open,
        close: context.close,
        toggle: context.toggleOpen,
        isOpen: context.isOpen
    };
};


/***/ }),

/***/ 68568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProjectIsPendingVerification; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90489);






function ProjectIsPendingVerification(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "orange.500",
        position: "absolute",
        width: "100%",
        top: 0,
        py: 2,
        px: 8,
        borderRadius: "md"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
            as: "span",
            fontSize: "sm",
            textTransform: "uppercase",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                defaultMessage: "This project will be published once it is verified. <link>Learn More.</link>",
                id: "d725dH",
                values: {
                    link: function(text) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Anchor */ .ee, {
                            external: "outside-redirect",
                            href: "https://help.govlaunch.com/en/articles/3740777-how-do-i-verify-my-projects",
                            children: text
                        });
                    }
                }
            })
        })
    }));
};


/***/ }),

/***/ 63331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProjectWithActions; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(81871);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+project@2.37.38_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/project/index.ts + 59 modules
var _govlaunch_project = __webpack_require__(78062);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var components_message = __webpack_require__(90489);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
;// CONCATENATED MODULE: ./components/seo/ProjectPageSeo.tsx




function ProjectPageSeo(param) {
    var projectTitle = param.projectTitle, projectDescription = param.projectDescription;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
        title: "".concat(projectTitle, " - Govlaunch ").concat(intl.formatMessage({
            defaultMessage: "Projects",
            id: "UxTJRa"
        })),
        description: projectDescription || projectTitle
    });
};

// EXTERNAL MODULE: ./components/vendor/profile/UpgradeToMakersProBanner.tsx
var UpgradeToMakersProBanner = __webpack_require__(589);
// EXTERNAL MODULE: ./lib/apollo/RefetchQueriesFixLink.ts
var RefetchQueriesFixLink = __webpack_require__(69086);
// EXTERNAL MODULE: ./lib/mutations/ToggleBookmarkMutation.ts
var ToggleBookmarkMutation = __webpack_require__(19805);
// EXTERNAL MODULE: ./lib/mutations/ToggleUpvoteMutation.ts
var ToggleUpvoteMutation = __webpack_require__(22662);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
// EXTERNAL MODULE: ./src/utils/nextLinkHref.ts
var nextLinkHref = __webpack_require__(88196);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/moment@2.29.4/node_modules/moment/moment.js
var moment = __webpack_require__(98777);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/.pnpm/draft-js@0.11.7_sfoxds7t5ydpegc3knd667wn6m/node_modules/draft-js/lib/Draft.js
var Draft = __webpack_require__(12727);
;// CONCATENATED MODULE: ./src/components/comments/icons.tsx




function UpvoteIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "23",
        height: "21",
        viewBox: "0 0 23 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M12.8611 7.06515V7.56515H13.3611H20.0232C20.9212 7.56515 21.6607 8.25075 21.7303 9.0883C21.7647 9.50237 21.6279 9.90899 21.3231 10.2148C20.9997 10.5391 20.5744 10.713 20.161 10.713H19.7016H19.092L19.2112 11.3108C19.2543 11.527 19.2916 11.7584 19.2934 11.9796C19.2533 12.4956 18.9385 12.9783 18.4991 13.2157L18.0491 13.4587L18.3023 13.9031C18.4185 14.1071 18.4652 14.4087 18.4664 14.7482C18.4269 15.4085 18.0149 15.9237 17.4212 16.1339L16.8885 16.3225L17.1406 16.8283C17.2283 17.0042 17.2698 17.2331 17.2718 17.5057C17.1917 18.3469 16.4902 19.0087 15.6124 19.0087H12.672C12.5193 19.0087 12.2835 19.0228 12.0099 19.0392C11.9203 19.0445 11.8267 19.0502 11.7306 19.0556C11.3264 19.0784 10.8433 19.1009 10.3288 19.1009C9.14158 19.1009 7.839 19.0068 6.91637 18.6703L6.24503 18.4254V19.14V19.8313C6.24503 19.9253 6.14582 20.0226 6.05585 20.0226H1.27756C1.18759 20.0226 1.08838 19.9253 1.08838 19.8313V7.01906C1.08838 6.92505 1.18759 6.82776 1.27756 6.82776H6.00991C6.08814 6.82776 6.13534 6.85149 6.15992 6.87145C6.18356 6.89064 6.19903 6.91585 6.20408 6.9513L6.34542 7.94376L7.05318 7.23381L7.32885 6.95729L7.60453 6.68076C8.56927 5.71303 9.12878 4.38848 9.12878 3.00948C9.12878 2.4829 9.37099 1.97753 9.81254 1.604C10.2542 1.27625 10.8396 1.13385 11.3771 1.24104C12.2422 1.42277 12.8611 2.1819 12.8611 3.10165V7.06515ZM5.36668 19.64H5.86668V19.14V17.9878V8.44777V7.71037V7.21037H5.36668H1.96673H1.46673V7.71037V19.14V19.64H1.96673H5.36668ZM6.19908 17.7113V17.9784L6.42114 18.1269C6.709 18.3194 7.11256 18.4474 7.54005 18.5381C7.9805 18.6316 8.49897 18.6959 9.05363 18.7343C10.1555 18.8108 11.4368 18.7879 12.6049 18.6722H12.626H15.5665C16.1478 18.6722 16.8476 18.2689 16.8476 17.5269C16.8476 17.2659 16.7822 16.9321 16.5179 16.667C16.31 16.4585 16.0053 16.2896 15.6584 16.2896C15.5684 16.2896 15.4692 16.1923 15.4692 16.0982C15.4692 16.0042 15.5684 15.9069 15.6584 15.9069H16.807C17.3884 15.9069 18.0881 15.5036 18.0881 14.7617C18.0881 14.5007 18.0227 14.1669 17.7584 13.9018C17.5506 13.6933 17.2459 13.5243 16.8989 13.5243C16.8089 13.5243 16.7097 13.427 16.7097 13.333C16.7097 13.239 16.8089 13.1417 16.8989 13.1417H17.634C18.2154 13.1417 18.9151 12.7384 18.9151 11.9965C18.9151 11.7355 18.8498 11.4017 18.5854 11.1365C18.3776 10.928 18.0729 10.7591 17.7259 10.7591C17.636 10.7591 17.5367 10.6618 17.5367 10.5678C17.5367 10.4738 17.636 10.3765 17.7259 10.3765H20.1151C20.462 10.3765 20.7667 10.2075 20.9746 9.99905C21.2389 9.73389 21.3042 9.40011 21.3042 9.13908V9.10804L21.3004 9.07725C21.2203 8.43466 20.6644 7.99386 20.0232 7.99386H13.3611C12.8927 7.99386 12.4828 7.60924 12.4828 7.11124V3.10165C12.4828 2.40955 12.0383 1.74029 11.2967 1.64157C10.8047 1.51595 10.38 1.67279 10.0618 1.92821C9.72264 2.20034 9.50714 2.6164 9.50714 3.05556C9.50714 4.5385 8.91513 5.9736 7.86845 6.98152L7.86838 6.98144L7.86118 6.98867C7.27058 7.58109 6.68279 8.12499 6.37311 8.39125L6.19908 8.54087V8.77038V17.7113Z",
            fill: "white",
            stroke: "#086BE5"
        })
    });
}
function UpvotedIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        width: "23",
        height: "21",
        viewBox: "0 0 23 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M12.8611 7.06515V7.56515H13.3611H20.0232C20.9212 7.56515 21.6607 8.25075 21.7303 9.0883C21.7647 9.50237 21.6279 9.90899 21.3231 10.2148C20.9997 10.5391 20.5744 10.713 20.161 10.713H19.7016H19.092L19.2112 11.3108C19.2543 11.527 19.2916 11.7584 19.2934 11.9796C19.2533 12.4956 18.9385 12.9783 18.4991 13.2157L18.0491 13.4587L18.3023 13.9031C18.4185 14.1071 18.4652 14.4087 18.4664 14.7482C18.4269 15.4085 18.0149 15.9237 17.4212 16.1339L16.8885 16.3225L17.1406 16.8283C17.2283 17.0042 17.2698 17.2331 17.2718 17.5057C17.1917 18.3469 16.4902 19.0087 15.6124 19.0087H12.672C12.5193 19.0087 12.2835 19.0228 12.0099 19.0392C11.9203 19.0445 11.8267 19.0502 11.7306 19.0556C11.3264 19.0784 10.8433 19.1009 10.3288 19.1009C9.14158 19.1009 7.839 19.0068 6.91637 18.6703L6.24503 18.4254V19.14V19.8313C6.24503 19.9253 6.14582 20.0226 6.05585 20.0226H1.27756C1.18759 20.0226 1.08838 19.9253 1.08838 19.8313V7.01906C1.08838 6.92505 1.18759 6.82776 1.27756 6.82776H6.00991C6.08814 6.82776 6.13534 6.85149 6.15992 6.87145C6.18356 6.89064 6.19903 6.91585 6.20408 6.9513L6.34542 7.94376L7.05318 7.23381L7.32885 6.95729L7.60453 6.68076C8.56927 5.71303 9.12878 4.38848 9.12878 3.00948C9.12878 2.4829 9.37099 1.97753 9.81254 1.604C10.2542 1.27625 10.8396 1.13385 11.3771 1.24104C12.2422 1.42278 12.8611 2.1819 12.8611 3.10165V7.06515ZM5.36668 19.64H5.86668V19.14V17.9878V8.44777V7.71037V7.21037H5.36668H1.96673H1.46673V7.71037V19.14V19.64H1.96673H5.36668ZM12.555 17.6722L12.5302 17.6747C11.4077 17.7873 10.1725 17.8095 9.12283 17.7367C8.59779 17.7003 8.12844 17.6407 7.74762 17.5599C7.517 17.511 7.33531 17.4576 7.19908 17.4048V8.99694C7.5461 8.68787 8.05677 8.20872 8.56583 7.69823C9.81406 6.49418 10.5071 4.797 10.5071 3.05556C10.5071 2.94169 10.5673 2.8047 10.6876 2.70813C10.8196 2.60223 10.9308 2.57632 11.064 2.61447L11.1071 2.62684L11.1518 2.63132C11.3021 2.64639 11.4828 2.79373 11.4828 3.10165V7.11124C11.4828 8.1802 12.3593 8.99386 13.3611 8.99386H20.0232C20.1925 8.99386 20.28 9.08705 20.3031 9.17533C20.298 9.25491 20.2763 9.28305 20.2664 9.29303C20.1985 9.36106 20.1357 9.37647 20.1151 9.37647H17.7259C17.0808 9.37647 16.5367 9.9244 16.5367 10.5678C16.5367 11.2112 17.0808 11.7591 17.7259 11.7591C17.7465 11.7591 17.8094 11.7745 17.8772 11.8425C17.8886 11.8539 17.9151 11.8888 17.9151 11.9965C17.9151 12.0029 17.9142 12.0293 17.8667 12.0674C17.8165 12.1077 17.733 12.1417 17.634 12.1417H16.8989C16.2538 12.1417 15.7097 12.6896 15.7097 13.333C15.7097 13.9764 16.2538 14.5243 16.8989 14.5243C16.9195 14.5243 16.9824 14.5397 17.0502 14.6078C17.0615 14.6191 17.0881 14.6541 17.0881 14.7617C17.0881 14.7681 17.0872 14.7945 17.0397 14.8326C16.9895 14.8729 16.906 14.9069 16.807 14.9069H15.6584C15.0132 14.9069 14.4692 15.4549 14.4692 16.0982C14.4692 16.7416 15.0132 17.2896 15.6584 17.2896C15.679 17.2896 15.7419 17.305 15.8097 17.373C15.821 17.3844 15.8476 17.4193 15.8476 17.5269C15.8476 17.5333 15.8467 17.5597 15.7992 17.5979C15.7489 17.6382 15.6655 17.6722 15.5665 17.6722H12.626H12.5801H12.555ZM6.19908 17.9784L6.42114 18.1269C6.709 18.3194 7.11256 18.4474 7.54005 18.5381C7.9805 18.6316 8.49897 18.6959 9.05363 18.7343C10.1555 18.8108 11.4368 18.7879 12.6049 18.6722H12.626H15.5665C16.1478 18.6722 16.8476 18.2689 16.8476 17.5269C16.8476 17.2659 16.7822 16.9321 16.5179 16.667C16.31 16.4585 16.0053 16.2896 15.6584 16.2896C15.5684 16.2896 15.4692 16.1923 15.4692 16.0982C15.4692 16.0042 15.5684 15.9069 15.6584 15.9069H16.807C17.3884 15.9069 18.0881 15.5037 18.0881 14.7617C18.0881 14.5007 18.0227 14.1669 17.7584 13.9018C17.5506 13.6933 17.2459 13.5243 16.8989 13.5243C16.8089 13.5243 16.7097 13.427 16.7097 13.333C16.7097 13.239 16.8089 13.1417 16.8989 13.1417H17.634C18.2154 13.1417 18.9151 12.7384 18.9151 11.9965C18.9151 11.7354 18.8498 11.4017 18.5854 11.1365C18.3776 10.928 18.0729 10.7591 17.7259 10.7591C17.636 10.7591 17.5367 10.6618 17.5367 10.5678C17.5367 10.4738 17.636 10.3765 17.7259 10.3765H20.1151C20.462 10.3765 20.7667 10.2075 20.9746 9.99904C21.2389 9.73389 21.3042 9.40011 21.3042 9.13908V9.10804L21.3004 9.07725C21.2203 8.43466 20.6644 7.99386 20.0232 7.99386H13.3611C12.8927 7.99386 12.4828 7.60924 12.4828 7.11124V3.10165C12.4828 2.40955 12.0383 1.74029 11.2967 1.64157C10.8047 1.51595 10.38 1.67279 10.0618 1.92821C9.72264 2.20034 9.50714 2.6164 9.50714 3.05556C9.50714 4.5385 8.91513 5.9736 7.86845 6.98152L7.86838 6.98144L7.86118 6.98867C7.27058 7.58109 6.68279 8.12499 6.37311 8.39125L6.19908 8.54087V8.77038V17.7113V17.9784Z",
            fill: "#086BE5",
            stroke: "#086BE5"
        })
    });
}
function ReplyIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "16",
        height: "11",
        viewBox: "0 0 16 11",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.00042 4.32678C2.00035 4.33036 2.00024 4.33447 2.00009 4.33909C2.00002 4.33632 2.00042 4.33224 2.00042 4.32678C2.00042 4.32131 2.00002 4.31723 2.00009 4.31446C2.00024 4.31908 2.00035 4.32319 2.00042 4.32678ZM2.38796 4.34008L4.07469 6.6533H13.2245C13.4898 6.6533 13.7486 6.67248 14 6.70892V2.77575C14 2.3293 13.6709 2.00024 13.2245 2.00024H4.14283L2.38796 4.34008ZM3.02038 0.163509C3.10202 0.0818766 3.18365 0.000244141 3.34691 0.000244141H13.2245C14.7755 0.000244141 16 1.22473 16 2.77575V10.0411C15.5002 9.4163 14.8091 8.93499 14 8.74349C13.7519 8.68477 13.4927 8.6533 13.2245 8.6533H3.26528C3.18365 8.6533 3.02038 8.57167 2.93875 8.49004L0.0816078 4.57167C-2.47955e-05 4.49004 -2.47955e-05 4.40841 -2.47955e-05 4.32677C-2.47955e-05 4.24514 -2.47955e-05 4.16351 0.0816078 4.08188L3.02038 0.163509Z",
            fill: "currentColor"
        })
    }));
}
function EditIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.09289 0.292893C9.48342 -0.0976311 10.1166 -0.0976311 10.5071 0.292893L13.7071 3.49289C14.0976 3.88342 14.0976 4.51658 13.7071 4.90711L4.90711 13.7071C4.71957 13.8946 4.46522 14 4.2 14H1C0.447715 14 0 13.5523 0 13V9.8C0 9.53478 0.105357 9.28043 0.292893 9.09289L9.09289 0.292893ZM2 10.2142V12H3.78579L11.5858 4.2L9.8 2.41421L2 10.2142Z",
            fill: "currentColor"
        })
    }));
}
function DeleteIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "8",
        height: "8",
        viewBox: "0 0 8 8",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M5.47758 3.99999L7.69411 1.78356C8.10196 1.37549 8.10196 0.714097 7.69411 0.306241C7.28611 -0.10208 6.62447 -0.10208 6.21633 0.306241L4.00002 2.52238L1.78367 0.306241C1.37557 -0.10208 0.713925 -0.10208 0.305891 0.306241C-0.101964 0.714097 -0.101964 1.37549 0.305891 1.78356L2.52245 3.99999L0.305891 6.21638C-0.101964 6.62416 -0.101964 7.28584 0.305891 7.69395C0.713925 8.10202 1.37557 8.10202 1.78367 7.69395L4.00002 5.47752L6.21633 7.69395C6.62447 8.10202 7.28611 8.10202 7.69411 7.69395C8.10196 7.28584 8.10196 6.62416 7.69411 6.21638L5.47758 3.99999Z",
            fill: "currentColor"
        })
    }));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./src/components/comments/graphql/fragments/CommentFieldsFragment.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CommentFields on Comment {\n    _id\n    author {\n      ... on GovernmentUser {\n        _id\n        avatar\n        firstName\n        fullName\n        title\n        slug\n        government {\n          _id\n          city {\n            _id\n            country\n            countryName\n          }\n        }\n      }\n      ... on VendorUser {\n        _id\n        avatar\n        firstName\n        fullName\n        title\n        slug\n      }\n      ... on PendingUser {\n        _id\n        avatar\n        firstName\n        fullName\n        jobTitle\n        slug\n      }\n    }\n    body\n    createdAt\n    lastUpdatedAt\n    viewerDidUpvote\n    isReply\n    replies {\n      _id\n      author {\n        ... on GovernmentUser {\n          _id\n          avatar\n          firstName\n          fullName\n          title\n          slug\n          government {\n            _id\n            city {\n              _id\n              country\n              countryName\n            }\n          }\n        }\n        ... on VendorUser {\n          _id\n          avatar\n          firstName\n          fullName\n          title\n          slug\n        }\n        ... on PendingUser {\n          _id\n          avatar\n          firstName\n          fullName\n          jobTitle\n          slug\n        }\n      }\n      body\n      createdAt\n      lastUpdatedAt\n      viewerDidUpvote\n      isReply\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var CommentFieldsFragment = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./src/components/comments/graphql/WriteCommentMutation.ts

function WriteCommentMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation WriteComment($targetId: ObjectId!, $targetType: CommentTargetType!, $body: JSON!) {\n    createComment(targetId: $targetId, targetType: $targetType, body: $body) {\n      ...CommentFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    WriteCommentMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var WriteCommentMutation = ((0,lib/* gql */.Ps)(WriteCommentMutation_templateObject(), CommentFieldsFragment));

;// CONCATENATED MODULE: ./src/components/comments/graphql/CommentsListQuery.ts

function CommentsListQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CommentsList($targetId: ObjectId!, $targetType: CommentTargetType!, $cursor: Cursor) {\n    comments(targetId: $targetId, targetType: $targetType, cursor: $cursor) {\n      items {\n        ...CommentFields\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    CommentsListQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var CommentsListQuery = ((0,lib/* gql */.Ps)(CommentsListQuery_templateObject(), CommentFieldsFragment));

;// CONCATENATED MODULE: ./src/components/comments/graphql/ReplyCommentMutation.ts

function ReplyCommentMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ReplyComment($replyTo: ObjectId!, $body: JSON!) {\n    replyComment(replyTo: $replyTo, body: $body) {\n      _id\n      ...CommentFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    ReplyCommentMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var ReplyCommentMutation = ((0,lib/* gql */.Ps)(ReplyCommentMutation_templateObject(), CommentFieldsFragment));

;// CONCATENATED MODULE: ./src/components/comments/graphql/EditCommentMutation.ts

function EditCommentMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation EditComment($commentId: ObjectId!, $body: JSON!) {\n    editComment(id: $commentId, body: $body) {\n      ...CommentFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    EditCommentMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var EditCommentMutation = ((0,lib/* gql */.Ps)(EditCommentMutation_templateObject(), CommentFieldsFragment));

// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
;// CONCATENATED MODULE: ./src/components/comments/CommentForms.tsx










var validationSchema = es/* object */.Ry().shape({
    body: es/* string */.Z_().required().trim()
});
var FormBox = web/* Box.withComponent */.xu.withComponent("form");
var WriteCommentForm = function(param) {
    var onSubmit = param.onSubmit;
    var viewer = (0,Auth/* useSelfie */.yD)();
    var intl = (0,useIntl/* default */.Z)();
    if (!viewer) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
        onSubmit: onSubmit,
        validate: (0,validate/* default */.Z)(validationSchema),
        children: function(param) {
            var handleSubmit = param.handleSubmit, valid = param.valid, submitting = param.submitting;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormBox, {
                display: "flex",
                flexDirection: "column",
                as: "form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                mr: 2,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                    src: viewer.avatar,
                                    name: viewer.fullName,
                                    size: "sm"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                name: "body",
                                children: function(param) {
                                    var input = param.input;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ExpandingTextarea */.CU, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Write your comment...",
                                            id: "6jOrmJ"
                                        }),
                                        size: "sm"
                                    }, input), {
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Write your comment...",
                                            id: "6jOrmJ"
                                        })
                                    }));
                                }
                            })
                        ]
                    }),
                    valid && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                        justify: "flex-end",
                        mt: 3,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            loading: submitting,
                            loadingText: intl.formatMessage({
                                defaultMessage: "Commenting...",
                                id: "rEm9aW"
                            }),
                            type: "submit",
                            variant: "primary",
                            size: "sm",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                defaultMessage: "Comment",
                                id: "LgbKvU"
                            })
                        })
                    })
                ]
            });
        }
    });
};
var ReplyCommentForm = function(param) {
    var onSubmit = param.onSubmit;
    var viewer = (0,Auth/* useSelfie */.yD)();
    var intl = (0,useIntl/* default */.Z)();
    if (!viewer) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
        onSubmit: onSubmit,
        validate: (0,validate/* default */.Z)(validationSchema),
        children: function(param) {
            var handleSubmit = param.handleSubmit, valid = param.valid, submitting = param.submitting;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormBox, {
                display: "flex",
                flexDirection: "column",
                as: "form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                mr: 2,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                    src: viewer.avatar,
                                    name: viewer.fullName,
                                    size: "sm"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                name: "body",
                                children: function(param) {
                                    var input = param.input;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ExpandingTextarea */.CU, (0,_object_spread/* default */.Z)({
                                        autoFocus: true,
                                        size: "sm"
                                    }, input));
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                        justify: "flex-start",
                        mt: 3,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            disabled: !valid,
                            loading: submitting,
                            loadingText: intl.formatMessage({
                                defaultMessage: "Replying...",
                                id: "x4bZQK"
                            }),
                            type: "submit",
                            variant: "primary",
                            size: "sm",
                            ml: 10,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                defaultMessage: "Reply",
                                id: "9HU8vw"
                            })
                        })
                    })
                ]
            });
        }
    });
};
var EditCommentForm = function(param) {
    var onSubmit = param.onSubmit, initialValues = param.initialValues;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
        onSubmit: onSubmit,
        validate: (0,validate/* default */.Z)(validationSchema),
        initialValues: initialValues,
        children: function(param) {
            var handleSubmit = param.handleSubmit, valid = param.valid, submitting = param.submitting;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormBox, {
                display: "flex",
                flexDirection: "column",
                as: "form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                        name: "body",
                        children: function(param) {
                            var input = param.input;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ExpandingTextarea */.CU, (0,_object_spread/* default */.Z)({
                                autoFocus: true,
                                size: "sm"
                            }, input));
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                        justify: "flex-start",
                        mt: 3,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            disabled: !valid,
                            loading: submitting,
                            loadingText: intl.formatMessage({
                                defaultMessage: "Editing...",
                                id: "6CJjWk"
                            }),
                            type: "submit",
                            variant: "primary",
                            size: "sm",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                defaultMessage: "Edit",
                                id: "wEQDC6"
                            })
                        })
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./src/components/comments/graphql/DeleteCommentMutation.ts

function DeleteCommentMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeleteComment($commentId: ObjectId!, $targetId: ObjectId) {\n    removeComment(id: $commentId, targetId: $targetId)\n  }\n"
    ]);
    DeleteCommentMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var DeleteCommentMutation = ((0,lib/* gql */.Ps)(DeleteCommentMutation_templateObject()));

// EXTERNAL MODULE: ./src/shared/components/IntlRelativeTime.tsx
var IntlRelativeTime = __webpack_require__(89989);
;// CONCATENATED MODULE: ./src/components/comments/CommentsList.tsx

























function CommentsList(param) {
    var targetId = param.targetId, targetType = param.targetType, _viewerCanComment = param.viewerCanComment, viewerCanComment = _viewerCanComment === void 0 ? true : _viewerCanComment;
    var ref, ref1, ref2;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(WriteCommentMutation), 1), writeComment = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(EditCommentMutation), 1), editComment = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ReplyCommentMutation), 1), replyComment = ref5[0];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DeleteCommentMutation), 1), deleteComment = ref6[0];
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ToggleUpvoteMutation/* default */.Z), 1), toggleUpvote = ref7[0];
    var ref8 = (0,useQuery/* useQuery */.a)(CommentsListQuery, {
        variables: {
            targetId: targetId,
            targetType: targetType,
            cursor: null
        }
    }), data = ref8.data, loading = ref8.loading;
    if (!viewerCanComment && (data === null || data === void 0 ? void 0 : (ref = data.comments) === null || ref === void 0 ? void 0 : ref.items.length) === 0 && !loading) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        bg: "gray.100",
        borderRadius: "sm",
        py: 4,
        px: [
            1,
            8
        ],
        children: [
            viewerCanComment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WriteCommentForm, {
                onSubmit: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, form) {
                        var body;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    body = param.body;
                                    _ctx.next = 3;
                                    return writeComment({
                                        variables: {
                                            body: (0,Draft.convertToRaw)(Draft.ContentState.createFromText(body)),
                                            targetId: targetId,
                                            targetType: targetType
                                        }
                                    });
                                case 3:
                                    setTimeout(form.reset);
                                    return _ctx.abrupt("return", null);
                                case 5:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function(_, form) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {}),
            !loading && ((data === null || data === void 0 ? void 0 : (ref1 = data.comments) === null || ref1 === void 0 ? void 0 : ref1.items) || []).length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                mt: 4,
                px: [
                    1,
                    2
                ],
                py: 4,
                bg: "white",
                css: {
                    ".comment:last-child .comment__divider": {
                        display: "none"
                    },
                    ".comment:not(:first-of-type)": {
                        marginTop: 12
                    }
                },
                children: data === null || data === void 0 ? void 0 : (ref2 = data.comments) === null || ref2 === void 0 ? void 0 : ref2.items.sort(function(a, b) {
                    return sortComments(a, b);
                }).map(function(comment) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Comment, {
                        comment: comment,
                        viewerCanComment: viewerCanComment,
                        onToggleUpvote: function(comment) {
                            toggleUpvote({
                                variables: {
                                    targetType: types/* IUpvoteTargetType.Comment */.aj.Comment,
                                    targetId: comment._id
                                }
                            });
                        },
                        onReply: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                                var body;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            body = param.body;
                                            _ctx.next = 3;
                                            return replyComment({
                                                variables: {
                                                    body: (0,Draft.convertToRaw)(Draft.ContentState.createFromText(body)),
                                                    replyTo: comment._id
                                                }
                                            });
                                        case 3:
                                            return _ctx.abrupt("return", null);
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(_) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        onEdit: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(targetComment, param) {
                                var body;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            body = param.body;
                                            _ctx.next = 3;
                                            return editComment({
                                                variables: {
                                                    body: (0,Draft.convertToRaw)(Draft.ContentState.createFromText(body)),
                                                    commentId: targetComment._id
                                                }
                                            });
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(targetComment, _) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        onDelete: function(comment) {
                            deleteComment({
                                variables: {
                                    commentId: comment._id,
                                    targetId: targetId
                                }
                            });
                        }
                    }, comment._id);
                })
            })
        ]
    });
};
function Comment(_param) {
    var comment = _param.comment, _viewerCanComment = _param.viewerCanComment, viewerCanComment = _viewerCanComment === void 0 ? true : _viewerCanComment, onReply = _param.onReply, onEdit = _param.onEdit, onDelete = _param.onDelete, onToggleUpvote = _param.onToggleUpvote, props = (0,_object_without_properties/* default */.Z)(_param, [
        "comment",
        "viewerCanComment",
        "onReply",
        "onEdit",
        "onDelete",
        "onToggleUpvote"
    ]);
    var viewer = (0,Auth/* useSelfie */.yD)();
    var ref = (0,react.useState)(false), isReplying = ref[0], setIsReplying = ref[1];
    var ref1 = (0,react.useState)(false), isEditing = ref1[0], setIsEditing = ref1[1];
    var viewerIsAuthor = viewer && viewer._id === comment.author._id;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "comment"
    }, props), {
        children: [
            comment.author.slug ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/user?userSlug=".concat(comment.author.slug),
                as: "/@".concat(comment.author.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentAuthor, {
                    comment: comment
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentAuthor, {
                comment: comment
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                mt: 3,
                pl: 12,
                children: [
                    isEditing ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditCommentForm, {
                        initialValues: {
                            body: getCommentText(comment.body)
                        },
                        onSubmit: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, form) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return onEdit(comment, values, form);
                                        case 2:
                                            setIsEditing(false);
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(values, form) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        color: "gray.900",
                        fontSize: "sm",
                        children: getCommentText(comment.body)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Stack */.Kq, {
                        spacing: [
                            3,
                            5
                        ],
                        direction: "row",
                        mt: 2,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IconButton */.hU, {
                                "aria-label": "upvote",
                                icon: comment.viewerDidUpvote ? UpvotedIcon : UpvoteIcon,
                                minWidth: "auto",
                                size: "sm",
                                onClick: function() {
                                    return onToggleUpvote(comment);
                                }
                            }),
                            onReply && viewerCanComment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentToolbarButton, {
                                icon: ReplyIcon,
                                onClick: function() {
                                    return setIsReplying(!isReplying);
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                    defaultMessage: "Reply",
                                    id: "9HU8vw"
                                })
                            }),
                            viewerIsAuthor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentToolbarButton, {
                                icon: EditIcon,
                                onClick: function() {
                                    return setIsEditing(!isEditing);
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                    defaultMessage: "Edit",
                                    id: "wEQDC6"
                                })
                            }),
                            viewerIsAuthor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentToolbarButton, {
                                icon: DeleteIcon,
                                onClick: function() {
                                    return onDelete(comment);
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                    defaultMessage: "Delete",
                                    id: "K3r6DQ"
                                })
                            })
                        ]
                    }),
                    isReplying && onReply && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        my: 2,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReplyCommentForm, {
                            onSubmit: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values, form) {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return onReply(values, form);
                                            case 2:
                                                setIsReplying(false);
                                            case 3:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(values, form) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        })
                    }),
                    comment.isReply && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        height: "1px",
                        width: "100%",
                        bg: "gray.100",
                        pl: 12,
                        mt: 2,
                        className: "comment__reply__divider"
                    }),
                    !comment.isReply && comment.replies.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        height: "1px",
                        width: "100%",
                        bg: "gray.100",
                        pl: 12,
                        mt: 2,
                        className: "comment__divider"
                    })
                ]
            }),
            comment.replies.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                borderLeft: "2px",
                borderLeftColor: "blue.600",
                pl: 4,
                ml: [
                    8,
                    8,
                    12
                ],
                mt: 6,
                css: {
                    ".reply:last-child .comment__reply__divider": {
                        display: "none"
                    },
                    ".reply:not(:first-of-type)": {
                        marginTop: 16
                    }
                },
                children: comment.replies.map(function(reply) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Comment, {
                        comment: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reply), {
                            replies: []
                        }),
                        className: "reply",
                        onDelete: onDelete,
                        onEdit: onEdit,
                        onToggleUpvote: onToggleUpvote,
                        onReply: onReply
                    }, reply._id);
                })
            })
        ]
    }));
}
var CommentAuthor = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var comment = _param.comment, props = (0,_object_without_properties/* default */.Z)(_param, [
        "comment"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "a",
        align: "center"
    }, props), {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                src: comment.author.avatar,
                name: comment.author.fullName || comment.author.firstName,
                size: "sm"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                ml: [
                    2,
                    2,
                    4
                ],
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                        color: "gray.900",
                        fontSize: "md",
                        children: [
                            comment.author.fullName || comment.author.firstName,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                                as: "span",
                                fontSize: "xs",
                                color: "gray.500",
                                ml: 2,
                                children: [
                                    "• ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                        value: new Date(comment.lastUpdatedAt || comment.createdAt)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        display: "flex",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                            color: "gray.500",
                            fontSize: "xs",
                            children: [
                                comment.author.__typename === "PendingUser" ? comment.author.jobTitle : comment.author.title,
                                comment.author.__typename === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                                    bg: "blue.600",
                                    label: comment.author.government.city.countryName,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                        display: "inline-flex",
                                        ml: 1,
                                        as: "span",
                                        verticalAlign: "top",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                            width: 29,
                                            height: 14,
                                            countryCode: comment.author.government.city.country
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
});
CommentAuthor.displayName = "CommentAuthor";
function CommentToolbarButton(_param) {
    var icon = _param.icon, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        leftIcon: icon,
        color: "gray.400",
        px: 0,
        fontWeight: "normal",
        size: "sm"
    }, props), {
        children: children
    }));
}
function getCommentText(rawCommentBody) {
    var contentState = (0,Draft.convertFromRaw)(rawCommentBody);
    return contentState.getBlocksAsArray().map(function(block) {
        var text = block.getText().trim();
        return text || "\n";
    }).join("\n");
}
function sortComments(a, b) {
    var dateA = moment_default()(a.createdAt).format("YYYY-MM-DD hh:mm:ss");
    var dateB = moment_default()(b.createdAt).format("YYYY-MM-DD hh:mm:ss");
    if (dateA < dateB) {
        return 1;
    }
    if (dateA > dateB) {
        return -1;
    }
    return 0;
}

// EXTERNAL MODULE: ./src/components/auth/useSignInModal.ts
var useSignInModal = __webpack_require__(51170);
;// CONCATENATED MODULE: ./src/components/comments/GatedCommentsList.tsx






function GatedCommentsList(param) {
    var _text = param.text, text = _text === void 0 ? "\uD83D\uDEAB You must be a verified user to join the discussion." : _text;
    var user = (0,Auth/* useSelfie */.yD)();
    var open = (0,useSignInModal/* default */.Z)().open;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        px: 8,
        py: 4,
        bg: "gray.100",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
            bg: "white",
            py: 1,
            px: 2,
            children: user ? text : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            marginRight: 2
                        },
                        children: "\uD83D\uDEAB"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                        defaultMessage: "To join the discussion, <link>sign up.</link> It's free!",
                        id: "qRAJSg",
                        values: {
                            // eslint-disable-next-line react/display-name
                            link: function(text) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                    as: "span",
                                    color: "blue.600",
                                    role: "button",
                                    onClick: open,
                                    cursor: "pointer",
                                    children: text
                                });
                            }
                        }
                    })
                ]
            })
        })
    });
};
function getGatedMessageFromUserType(viewer, param) {
    var pending = param.pending, citizen = param.citizen, community = param.community, vendor = param.vendor, government = param.government, fallbackMessage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /*#__PURE__*/ _jsxs("span", {
        children: [
            /*#__PURE__*/ _jsx("span", {
                css: {
                    marginRight: 2
                },
                children: "\uD83D\uDEAB"
            }),
            " ",
            /*#__PURE__*/ _jsx(FormattedMessage, {
                defaultMessage: "You must be a verified user to join the discussion.",
                id: "tRqSX+"
            })
        ]
    });
    if (!viewer) {
        return fallbackMessage;
    }
    if (viewer.__typename === "PendingUser") {
        if (viewer.role === "CITIZEN") {
            return citizen || fallbackMessage;
        }
        if (viewer.verified) {
            return community || fallbackMessage;
        }
        return pending || fallbackMessage;
    }
    if (viewer.__typename === "VendorUser") {
        return vendor || fallbackMessage;
    }
    if (viewer.__typename === "GovernmentUser") {
        return government || fallbackMessage;
    }
}

;// CONCATENATED MODULE: ./components/group/GroupLinkGatedContent.tsx




function GroupLinkGatedContent(param) {
    var isOpen = param.isOpen, message = param.message, onClose = param.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Modal */.u_, {
        isOpen: isOpen,
        onClose: onClose,
        isCentered: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalHeader */.xB, {
                        px: 2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalBody */.fe, {
                        textAlign: "center",
                        children: message
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalFooter */.mz, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            variantColor: "blue",
                            mr: 2,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                defaultMessage: "Close",
                                id: "rbrahO"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/project/ProjectGroupLink.tsx







function ProjectGroupLink(param) {
    var project = param.project, children = param.children;
    var ref = (0,react.useState)(false), showGate = ref[0], setShowGate = ref[1];
    var user = (0,Auth/* useSelfie */.yD)();
    var isNotMemberToPrivateGroup = project.visibility === types/* IGroupVisibility.Private */.tl.Private && project.viewerIsMember === false;
    var isPendingUser = project.visibility === types/* IGroupVisibility.Public */.tl.Public && (user === null || user === void 0 ? void 0 : user.__typename) === "PendingUser" && user.verified === false;
    var isVendorUserGate = project.kind === types/* IGroupKind.Discussion */.Tx.Discussion && (user === null || user === void 0 ? void 0 : user.__typename) === "VendorUser";
    if (isNotMemberToPrivateGroup || isPendingUser || isVendorUserGate) {
        var message = getGroupGateMessage(isNotMemberToPrivateGroup, isPendingUser, isVendorUserGate);
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupLinkGatedContent, {
                    isOpen: showGate,
                    message: message,
                    onClose: function() {
                        return setShowGate(false);
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    onClick: function(event) {
                        setShowGate(true);
                        event.preventDefault();
                    },
                    children: children
                })
            ]
        });
    }
    if (project.viewerIsMember || project.visibility === types/* IGroupVisibility.Public */.tl.Public) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: "/group?groupSlug=".concat(project.slug),
            as: "/groups/".concat(project.slug),
            passHref: true,
            children: children
        }, project._id);
    }
    return children;
};
function getGroupGateMessage(isNotMemberToPrivateGroup, isPendingUser, isVendorUserGate) {
    if (isNotMemberToPrivateGroup) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
            defaultMessage: "You must be a member to view this group.",
            id: "cpiboW"
        });
    }
    if (isPendingUser) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
            defaultMessage: "You must be a verified user to view this group.",
            id: "pCWodn"
        });
    }
    if (isVendorUserGate) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
            defaultMessage: "You must be a government user to view this group.",
            id: "0FRC5l"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
        defaultMessage: "Cannot open group profile.",
        id: "nrXtIc"
    });
}

;// CONCATENATED MODULE: ./src/components/project/createProjectLinkWrap.tsx





var createProjectLinkWrap = function(router) {
    return function(entity, children) {
        if (!entity) {
            return children;
        }
        if (entity.__typename === "Product") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/products/".concat(entity.slug),
                passHref: true,
                children: children
            }, entity._id);
        }
        if (entity.__typename === "Company") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/vendor?vendorSlug=".concat(entity.slug),
                as: "/vendors/".concat(entity.slug),
                passHref: true,
                children: children
            }, entity._id);
        }
        if (entity.__typename === "Government") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/government?governmentSlug=".concat(entity.slug),
                as: "/governments/".concat(entity.slug),
                passHref: true,
                children: children
            }, entity._id);
        }
        if (entity.__typename === "Group") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectGroupLink, {
                project: entity,
                children: children
            }, entity._id);
        }
        if (entity.__typename === "GovernmentProject" || entity.__typename === "VendorProject" || entity.__typename === "GroupProject") {
            var linkHref = (0,nextLinkHref/* appendNextLinkHrefParams */.o)(router, {
                projectSlug: entity.slug
            });
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: linkHref,
                as: "/projects/".concat(entity.slug),
                passHref: true,
                children: children
            }, entity._id);
        }
        if (entity.__typename === "PendingUser" || entity.__typename === "VendorUser" || entity.__typename === "GovernmentUser") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/user?userSlug=".concat(entity.slug),
                as: "/@".concat(entity.slug),
                passHref: true,
                children: children
            }, entity._id);
        }
        return children;
    };
};
/* harmony default export */ var project_createProjectLinkWrap = (createProjectLinkWrap);

;// CONCATENATED MODULE: ./src/components/project/graphql/ArchiveProjectMutation.ts

function ArchiveProjectMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArchiveProject($projectId: ObjectId!) {\n    archiveProject(projectId: $projectId)\n  }\n"
    ]);
    ArchiveProjectMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ArchiveProjectMutation = ((0,lib/* gql */.Ps)(ArchiveProjectMutation_templateObject()));

;// CONCATENATED MODULE: ./src/components/project/graphql/DeclineProjectVerificationMutation.ts

function DeclineProjectVerificationMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeclineProjectVerification($projectId: ObjectId!, $governmentId: ObjectId!) {\n    declineProjectVerification(projectId: $projectId, governmentId: $governmentId) {\n      _id\n      project {\n        ...ProjectFields\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    DeclineProjectVerificationMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var DeclineProjectVerificationMutation = ((0,lib/* gql */.Ps)(DeclineProjectVerificationMutation_templateObject(), _govlaunch_project/* ProjectFieldsFragment */.Gj));

;// CONCATENATED MODULE: ./src/components/project/graphql/VerifyProjectMutation.ts

function VerifyProjectMutation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation VerifyProject($projectId: ObjectId!, $governmentId: ObjectId!) {\n    verifyProject(projectId: $projectId, governmentId: $governmentId) {\n      _id\n      project {\n        ...ProjectFields\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    VerifyProjectMutation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var VerifyProjectMutation = ((0,lib/* gql */.Ps)(VerifyProjectMutation_templateObject(), _govlaunch_project/* ProjectFieldsFragment */.Gj));

// EXTERNAL MODULE: ./components/invite/Collaborator.tsx + 1 modules
var Collaborator = __webpack_require__(84743);
// EXTERNAL MODULE: ./components/invite/InviteModal.tsx + 4 modules
var InviteModal = __webpack_require__(96805);
;// CONCATENATED MODULE: ./src/components/project/ProjectCollaborators.tsx






function ProjectCollaborators(param) {
    var project = param.project;
    var ref = (0,react.useState)(false), showInviteModal = ref[0], setShowInviteModal = ref[1];
    var intl = (0,useIntl/* default */.Z)();
    if (!project.viewerCanInviteCollaborators && project.collaborators.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        borderRadius: "md",
        border: "solid 1px",
        borderColor: "gray.200",
        pt: 2,
        px: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                color: "blue.600",
                fontSize: "lg",
                fontWeight: "bold",
                mb: 1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                    defaultMessage: "Collaborators",
                    id: "9Jstnt"
                })
            }),
            project.viewerCanInviteCollaborators && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                alignItems: "center",
                mb: 2,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                    fontSize: "sm",
                    color: "gray.600",
                    mr: 1,
                    lineHeight: "18px",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                            defaultMessage: "Have you collaborated with someone on this Project?",
                            id: "pHy3pK"
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            variant: "link",
                            fontSize: "sm",
                            color: "blue.600",
                            fontWeight: "normal",
                            lineHeight: "18px",
                            verticalAlign: "baseline",
                            onClick: function() {
                                return setShowInviteModal(true);
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                defaultMessage: "Invite them!",
                                id: "6vp4p4"
                            })
                        })
                    ]
                })
            }),
            project.collaborators.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                wrap: "wrap",
                children: project.collaborators.map(function(collaborator) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        mb: 2,
                        mr: 4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Collaborator/* default */.Z, {
                            user: collaborator,
                            viewerCanRemove: project.viewerCanRemoveCollaborators,
                            targetId: project._id,
                            targetType: "PROJECT"
                        })
                    }, collaborator._id);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviteModal/* default */.Z, {
                title: intl.formatMessage({
                    defaultMessage: "Invite Collaborators",
                    id: "WzMyYb"
                }),
                subtitle: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                        defaultMessage: "They’ll be granted with <strong>Edit</strong> access to this <strong>Project.</strong>",
                        id: "rPBob9",
                        values: {
                            // eslint-disable-next-line react/display-name
                            strong: function(text) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                    children: text
                                });
                            }
                        }
                    })
                }),
                targetType: "PROJECT",
                targetId: project._id,
                isOpen: showInviteModal,
                onRequestClose: function() {
                    return setShowInviteModal(false);
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
;// CONCATENATED MODULE: ./lib/mutations/CancelVerificationRequestFromProjectByGovernmentId.ts

function CancelVerificationRequestFromProjectByGovernmentId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelVerificationRequestFromProjectByGovernmentId($projectId: ObjectId!, $governmentId: ObjectId!) {\n    cancelVerificationRequestFromProjectByGovernmentId(projectId: $projectId, governmentId: $governmentId) {\n      _id\n      ...ProjectFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    CancelVerificationRequestFromProjectByGovernmentId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var CancelVerificationRequestFromProjectByGovernmentId = ((0,lib/* gql */.Ps)(CancelVerificationRequestFromProjectByGovernmentId_templateObject(), _govlaunch_project/* ProjectFieldsFragment */.Gj));

;// CONCATENATED MODULE: ./components/project/CancelVerificationRequest.tsx




function CancelVerificationRequest(param) {
    var projectId = param.projectId, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: CancelVerificationRequestFromProjectByGovernmentId,
        children: function(cancelVerificationRequest, param) {
            var loading = param.loading, error = param.error;
            return children({
                error: error,
                loading: loading,
                cancelVerificationRequest: function(governmentId) {
                    return cancelVerificationRequest({
                        variables: {
                            projectId: projectId,
                            governmentId: governmentId
                        }
                    });
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
// EXTERNAL MODULE: ./lib/utils/getGovlaunchBaseUrl.ts
var getGovlaunchBaseUrl = __webpack_require__(44673);
;// CONCATENATED MODULE: ./src/components/project/ProjectPendingVerifications.tsx








function ProjectPendingVerifications(param) {
    var project = param.project;
    if (project.locationsPendingVerification.length < 1 || !project.viewerCanEdit) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 16,
            padding: "24px 16px",
            backgroundColor: "#EBF4FA"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                fontSize: "md",
                color: "blue.600",
                fontWeight: "semibold",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                    defaultMessage: "Invitations pending for these governments...",
                    id: "XpVxZk"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CancelVerificationRequest, {
                projectId: project._id,
                children: function(param) {
                    var cancelVerificationRequest = param.cancelVerificationRequest, loading = param.loading, error = param.error;
                    var viewerCanRemove = project.locationsPendingVerification.length > 1;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: [
                                    "center",
                                    "center",
                                    "flex-start"
                                ],
                                children: project.locationsPendingVerification.map(function(location) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: "/government?governmentSlug=".concat(location.slug),
                                        as: "/governments/".concat(location.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                            css: {
                                                position: "relative",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                color: "unset",
                                                textDecoration: "none",
                                                marginRight: 16,
                                                marginBottom: 16
                                            },
                                            children: [
                                                viewerCanRemove && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                                    type: "button",
                                                    disabled: loading,
                                                    css: {
                                                        position: "absolute",
                                                        top: -5,
                                                        right: -5,
                                                        zIndex: 2,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        width: 20,
                                                        height: 20,
                                                        color: "#fff",
                                                        fontWeight: 600,
                                                        fontSize: 18,
                                                        background: "red",
                                                        border: "none",
                                                        borderRadius: "100%",
                                                        outline: "none",
                                                        cursor: "pointer",
                                                        pointerEvents: loading ? "none" : "all",
                                                        WebkitAppearance: "none"
                                                    },
                                                    onClick: function(event) {
                                                        event.preventDefault();
                                                        cancelVerificationRequest(location._id);
                                                    },
                                                    children: "\xd7"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                                                    label: location.name,
                                                    bg: "blue.600",
                                                    px: 2,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                                        position: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                                size: "lg",
                                                                src: location.logo,
                                                                name: location.name
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                                position: "absolute",
                                                                bottom: 1,
                                                                right: -3,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                                                    countryCode: location.city.country,
                                                                    width: 24,
                                                                    height: 14
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }, location._id);
                                })
                            }),
                            error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                color: "red.600",
                                fontWeight: "semibold",
                                fontSize: "sm",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                    defaultMessage: "Couldn't process your request. Try again later in a few minutes.",
                                    id: "Bz/cF8"
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                initial: false,
                children: function(param) {
                    var on = param.on, set = param.set;
                    if (on) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridRowGap: 16
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        css: {
                                            margin: 0,
                                            fontSize: 14,
                                            lineHeight: 1.33,
                                            color: "#0071BB",
                                            fontWeight: 500,
                                            letterSpacing: 0.8
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                                            defaultMessage: "Send this project link to collaborators who will be able to confirm their involvement",
                                            id: "8ZOnKn"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                        value: "".concat((0,getGovlaunchBaseUrl/* default */.Z)(), "/projects/").concat(project.slug),
                                        onChange: function() {},
                                        readOnly: true,
                                        onFocus: function(event) {
                                            event.target.select();
                                        },
                                        css: {
                                            boxSizing: "border-box",
                                            padding: 12,
                                            color: "#48A0DA",
                                            fontWeight: 500,
                                            fontSize: 14,
                                            textAlign: "center",
                                            fontFamily: "Courier",
                                            backgroundColor: "transparent",
                                            border: "dashed 1px #48A0DA",
                                            borderRadius: 4,
                                            outline: "none",
                                            WebkitAppearance: "none"
                                        }
                                    })
                                ]
                            })
                        });
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                        rounded: "lg",
                        onClick: function() {
                            return set(true);
                        },
                        variant: "solid",
                        variantColor: "blue",
                        mx: "auto",
                        maxWidth: "300px",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                            defaultMessage: "Invite Governments Now",
                            id: "bXCN64"
                        })
                    });
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/project/ProjectWithActions.tsx



























function ProjectWithActions(param) {
    var loading = param.loading, project = param.project, onDeleteProject = param.onDeleteProject, onClickProject = param.onClickProject, onVerify = param.onVerify, translationButton = param.translationButton;
    var viewer = (0,Auth/* useSelfie */.yD)();
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ToggleUpvoteMutation/* default */.Z), 1), toggleUpvote = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ToggleBookmarkMutation/* default */.Z), 1), toggleBookmark = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(ArchiveProjectMutation, {
        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
            "Vendor",
            "CompanyAccountBillingInfo"
        ])
    }), 1), archiveProject = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(VerifyProjectMutation, {
        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
            "ProjectsByGovernment",
            "VerifiedGovernmentProjects"
        ])
    }), 1), verifyProject = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(DeclineProjectVerificationMutation, {
        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
            "ProjectsByGovernment",
            "VerifiedGovernmentProjects"
        ])
    }), 1), declineProjectVerification = ref4[0];
    var renderLinkWrap = project_createProjectLinkWrap(router);
    var renderEditLinkWrap = function(children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: "/projects/[projectSlug]/edit",
            as: "/projects/".concat(project === null || project === void 0 ? void 0 : project.slug, "/edit"),
            passHref: true,
            children: children
        });
    };
    if (!loading && viewer && viewer.__typename === "VendorUser" && !(project === null || project === void 0 ? void 0 : project.viewerCanView)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeToMakersProBanner/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectLoading */.jF, {}),
            !loading && project && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectPageSeo, {
                        projectTitle: project.title,
                        projectDescription: project.description
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        px: [
                            1,
                            1,
                            0
                        ],
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                            gridRowGap: 4,
                            backgroundColor: "white",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectHeader */.T4, {
                                    project: project,
                                    renderEditLinkWrap: renderEditLinkWrap,
                                    onDelete: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    _ctx.next = 2;
                                                    return archiveProject({
                                                        variables: {
                                                            projectId: project._id
                                                        }
                                                    });
                                                case 2:
                                                    onDeleteProject();
                                                case 3:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    })),
                                    actionButtons: {
                                        upvote: !!viewer,
                                        bookmark: !!viewer
                                    },
                                    onToggleUpvote: function() {
                                        toggleUpvote({
                                            variables: {
                                                targetType: types/* IUpvoteTargetType.Project */.aj.Project,
                                                targetId: project._id
                                            }
                                        });
                                    },
                                    onToggleBookmark: function() {
                                        toggleBookmark({
                                            variables: {
                                                targetType: types/* IBookmarkType.Project */.Cw.Project,
                                                targetId: project._id
                                            }
                                        });
                                    },
                                    translationButton: translationButton
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectIntroduction */.yl, {
                                    project: project
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectTags */.v6, {
                                    tags: project.tags,
                                    renderTagLinkWrap: function(tag, children) {
                                        var linkHref = (0,nextLinkHref/* default */.Z)("/collections/[collectionSlug]/[[...tab]]", {
                                            collectionSlug: tag.slug
                                        });
                                        var linkAs = "/collections/".concat(tag.slug, "/projects");
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: linkHref,
                                            as: linkAs,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                href: linkAs,
                                                children: children
                                            })
                                        }, linkAs);
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectPendingVerifications, {
                                    project: project
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectViewerVerification */.K6, {
                                    locationsPendingVerification: project.locationsPendingVerification,
                                    onVerifyPendingLocation: function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(locationId) {
                                            return runtime_default().wrap(function _callee$(_ctx) {
                                                while(1)switch(_ctx.prev = _ctx.next){
                                                    case 0:
                                                        _ctx.next = 2;
                                                        return verifyProject({
                                                            variables: {
                                                                projectId: project._id,
                                                                governmentId: locationId
                                                            }
                                                        });
                                                    case 2:
                                                        if (onVerify) {
                                                            onVerify();
                                                        }
                                                    case 3:
                                                    case "end":
                                                        return _ctx.stop();
                                                }
                                            }, _callee);
                                        }));
                                        return function(locationId) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    onDeclinePendingLocation: function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(locationId) {
                                            return runtime_default().wrap(function _callee$(_ctx) {
                                                while(1)switch(_ctx.prev = _ctx.next){
                                                    case 0:
                                                        _ctx.next = 2;
                                                        return declineProjectVerification({
                                                            variables: {
                                                                projectId: project._id,
                                                                governmentId: locationId
                                                            }
                                                        });
                                                    case 2:
                                                        if (onVerify) {
                                                            onVerify();
                                                        }
                                                    case 3:
                                                    case "end":
                                                        return _ctx.stop();
                                                }
                                            }, _callee);
                                        }));
                                        return function(locationId) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectEntity */.AE, {
                                    project: project,
                                    renderLinkWrap: renderLinkWrap
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectGovernments */.DJ, {
                                    governments: project.locations,
                                    renderLinkWrap: renderLinkWrap
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectProducts */.lU, {
                                    products: project.products,
                                    renderLinkWrap: renderLinkWrap
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectVendors */.Gt, {
                                    vendors: project.vendors,
                                    renderLinkWrap: renderLinkWrap
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectGroups */.FI, {
                                    groups: project.groups,
                                    renderLinkWrap: renderLinkWrap
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectLinks */.f5, {
                                    links: project.links
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectAttachments */.lR, {
                                    attachments: project.attachments
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectNewsworthy */.U2, {
                                    newsworthy: project.newsworthy
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectOutcome */.Rn, {
                                    outcome: project.outcome,
                                    outcomeStatement: project.outcomeStatement
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* ProjectAwards */.g_, {
                                    awards: project.awards
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectCollaborators, {
                                    project: project
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* MoreProjects */.cu, {
                                    project: project,
                                    onClickProject: onClickProject,
                                    renderLinkWrap: renderLinkWrap
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_project/* RelatedProjects */.z_, {
                                    relatedProjects: project.relatedProjects,
                                    onClickProject: onClickProject,
                                    renderLinkWrap: renderLinkWrap
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    my: 1,
                                    children: project.viewerCanComment ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommentsList, {
                                        targetId: project._id,
                                        targetType: types/* ICommentTargetType.Project */.VZ.Project,
                                        viewerCanComment: project.viewerCanComment
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GatedCommentsList, {
                                        text: getGatedCommentListMessage(project, viewer)
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
function getGatedCommentListMessage(project, viewer) {
    if (!viewer) {
        return null;
    }
    if (project.__typename === "GroupProject") {
        if (viewer.__typename === "PendingUser") {
            if (viewer.role === "CITIZEN") {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                marginRight: 2
                            },
                            children: "\uD83D\uDEAB"
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                            defaultMessage: "You must be a Government or Community verified user to join the discussion.",
                            id: "Bhriss"
                        })
                    ]
                });
            }
            if (!viewer.verified) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                marginRight: 2
                            },
                            children: "\uD83D\uDEAB"
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                            defaultMessage: "You must be a verified user to join the discussion.",
                            id: "tRqSX+"
                        })
                    ]
                });
            }
        }
        if (viewer.__typename === "VendorUser") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            marginRight: 2
                        },
                        children: "\uD83D\uDEAB"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                        defaultMessage: "You must be a Government user to join the discussion.",
                        id: "eFhXpV"
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: {
                        marginRight: 2
                    },
                    children: "\uD83D\uDEAB"
                }),
                " ",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                    defaultMessage: "You must be a group member to join the discussion.",
                    id: "UYXzML"
                })
            ]
        });
    }
    if (project.__typename === "GovernmentProject") {
        if (viewer.__typename === "PendingUser") {
            if (viewer.role === "CITIZEN") {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                marginRight: 2
                            },
                            children: "\uD83D\uDEAB"
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                            defaultMessage: "You must be a Government or Community verified user to join the discussion.",
                            id: "Bhriss"
                        })
                    ]
                });
            }
            if (!viewer.verified) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                marginRight: 2
                            },
                            children: "\uD83D\uDEAB"
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                            defaultMessage: "You must be a verified user to join the discussion.",
                            id: "tRqSX+"
                        })
                    ]
                });
            }
        }
        if (viewer.__typename === "VendorUser") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            marginRight: 2
                        },
                        children: "\uD83D\uDEAB"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                        defaultMessage: "You must be a Government user to join the discussion.",
                        id: "eFhXpV"
                    })
                ]
            });
        }
    }
    if (project.__typename === "VendorProject") {
        if (viewer.__typename === "PendingUser") {
            if (viewer.role === "CITIZEN") {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                marginRight: 2
                            },
                            children: "\uD83D\uDEAB"
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                            defaultMessage: "You must be a Government or Community verified user to join the discussion.",
                            id: "Bhriss"
                        })
                    ]
                });
            }
            if (!viewer.verified) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                marginRight: 2
                            },
                            children: "\uD83D\uDEAB"
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                            defaultMessage: "You must be a verified user to join the discussion.",
                            id: "tRqSX+"
                        })
                    ]
                });
            }
        }
        if (viewer.__typename === "VendorUser") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            marginRight: 2
                        },
                        children: "\uD83D\uDEAB"
                    }),
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_message/* default */.Z, {
                        defaultMessage: "You must be a Government user to join the discussion.",
                        id: "eFhXpV"
                    })
                ]
            });
        }
    }
}


/***/ }),

/***/ 94223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _govlaunch_project__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78062);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ProjectBySlug($slug: String!, $token: String, $language: String) {\n    projectBySlug(slug: $slug, language: $language) {\n      ...ProjectFields\n\n      viewerCanRead\n      viewerCanView\n      updatedAt\n\n      viewerCanInviteCollaborators\n      viewerCanRemoveCollaborators\n      viewerCanComment\n      collaborators(token: $token) {\n        ... on GovernmentUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n        }\n        ... on VendorUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n        }\n        ... on PendingUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _govlaunch_project__WEBPACK_IMPORTED_MODULE_1__/* .ProjectFieldsFragment */ .Gj));


/***/ }),

/***/ 77766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TranslateTo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56262);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35150);
/* harmony import */ var _src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98769);





function TranslateTo(param) {
    var langExists = param.langExists, showTranslateButton = param.showTranslateButton, //translated,
    //setTranslated,
    refetch = param.refetch, refetchOriginal = param.refetchOriginal;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(langExists), 2), translated = ref[0], setTranslated = ref[1];
    if (!showTranslateButton && !translated) {
        return null;
    }
    if (translated) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            showOriginal: true,
            onClick: function() {
                setTranslated(false);
                refetchOriginal();
            }
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        onClick: function() {
            setTranslated(true);
            refetch();
        }
    });
};


/***/ }),

/***/ 98769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TranslationButton; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90489);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67459);





function TranslationButton(param) {
    var showOriginal = param.showOriginal, onClick = param.onClick, paddingY = param.paddingY;
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
        color: isMobile ? "gray.900" : "blue.600",
        fontSize: isMobile ? "12px" : "14px",
        border: isMobile ? "1px solid #ADB6C3" : "",
        borderRadius: "4px",
        py: paddingY || "8px",
        px: "10px",
        onClick: onClick,
        _hover: {
            cursor: "pointer",
            opacity: 0.5
        },
        role: "button",
        children: showOriginal ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            defaultMessage: "see original",
            id: "/UVQql"
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            defaultMessage: "see translation",
            id: "jJqiqa"
        })
    });
};


/***/ })

}]);